<template>
    <div class="historyBox box">
        <div class="bg-gris-pro py-1 rounded-10">
            <div class="position-relative">
                <b-button class="tool p-0 border-0 bg-transparent d-block" :disabled="!canUndo" @click="undo()" @mouseover="tuto = 'undo'" @mouseleave="tuto = null">
                    <b-icon width="100%" height="100%" v-if="canUndo" icon="reply-fill" font-scale="1.5" flip-h rotate="20" />
                    <b-icon width="100%" height="100%" v-else icon="reply" font-scale="1.5" flip-h rotate="20" />
                </b-button>
                <div class="fly-over-tool animated fadeIn" v-if="tuto == 'undo'">
                    <div class="rounded-10 p-3 shadow-pro bg-white d-flex align-items-center">
                        <p class="text-dark mb-0 line-height pl-2"><t historyBox.tutoReturnBack /></p>
                    </div>
                </div>
            </div>
            <div class="position-relative">
                <b-button class="tool p-0 border-0 bg-transparent d-block" :disabled="!canRedo" @click="redo()" @mouseover="tuto = 'redo'" @mouseleave="tuto = null">
                    <b-icon width="100%" height="100%" v-if="canRedo" icon="reply-fill" font-scale="1.5" rotate="20"/>
                    <b-icon width="100%" height="100%" v-else icon="reply" font-scale="1.5" rotate="20" />
                </b-button>
                <div class="fly-over-tool animated fadeIn" v-if="tuto == 'redo'">
                    <div class="rounded-10 p-3 shadow-pro bg-white d-flex align-items-center">
                        <p class="text-dark mb-0 line-height pl-2"><t historyBox.tutoReturnFront /></p>
                    </div>
                </div>
            </div>

            <div class="position-relative">
                <b-button class="tool p-0 border-0 bg-transparent d-block" @click="select('ruler')" @mouseover="tuto = 'ruler'" @mouseleave="tuto = null">
                    <b-icon width="100%" height="100%" icon="rulers" font-scale="1.5" rotate="90"/>
                </b-button>
                <div class="fly-over-tool animated fadeIn" v-if="tuto == 'ruler'">
                    <div class="rounded-10 p-3 shadow-pro bg-white d-flex align-items-center">
                        <p class="text-dark mb-0 line-height pl-2"><t historyBox.rulers /></p>
                    </div>
                </div>
            </div>

            <div class="position-relative">
                <b-button class="tool p-0 border-0 bg-transparent d-block" @click="showDeleteModal" @mouseover="tuto = 'deleteAll'" @mouseleave="tuto = null">
                    <b-icon width="100%" height="100%" icon="trash-fill" font-scale="1.5" />
                </b-button>
                <div class="fly-over-tool animated fadeIn" v-if="tuto == 'deleteAll'">
                    <div class="rounded-10 p-3 shadow-pro bg-white d-flex align-items-center">
                        <p class="text-dark mb-0 line-height pl-2"><t historyBox.tutoDeleteAll /></p>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="modal-delete" ref="modal-delete" size="md" hide-header hide-footer no-close-on-backdrop no-close-on-esc centered body-class="d-flex justify-content-center flex-wrap">
            <img src="@/assets/img/delete-all.png" width="120">
            <p class="font-weight-bold mb-4 h5 line-height text-center mt-1"><t historyBox.confirmDelete /></p>
            <div class="col-6 px-2">
                <b-button class="btn btn-rouge border-0" block @click="hideDeleteModal">
                    <span class="font-weight-bold"><t historyBox.noDelete /></span>
                </b-button>
            </div>
            <div class="col-6 px-2">
                <b-button class="mt-0 btn btn-vert" block @click="deleteAll()">
                    <span class="font-weight-bold"><t historyBox.yesDelete /></span>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>


<script>
    /* eslint-disable vue/no-unused-components */
    import { BModal, VBModal, BIcon, BButton, BIconReply, BIconReplyFill, BIconTrashFill, BIconRulers } from 'bootstrap-vue'
    import { mapGetters, mapActions } from 'vuex'

    export default {
        components: { BModal, VBModal, BIcon, BButton, BIconReply, BIconReplyFill, BIconTrashFill, BIconRulers},
        directives: {'b-modal': VBModal},
        data() {
            return {
                tuto: null
            }
        },
        computed: {
            ...mapGetters([
                'canUndo',
                'canRedo',
                'tool',
                'shapes'
            ])
        },
        
        methods: {
            ...mapActions([
                'undo',
                'redo'
            ]),

            shortcutListener(event) {
                if (!event.ctrlKey) return;
                switch (event.key) {
                    case "z":
                        if (this.canUndo) this.undo();
                        break;
                    case "y":
                        if (this.canRedo) this.redo();
                        break;
                }
            },

            showDeleteModal() {
                this.$root.$emit('bv::show::modal', 'modal-delete');
            },

            hideDeleteModal() {
                this.$root.$emit('bv::hide::modal', 'modal-delete');
            },

            deleteAll() {
                this.shapes.forEach(shape => {
                    this.$store.dispatch('removeShapeId', shape.id);
                });
                
                this.$store.dispatch('setSelectedShapes', []);
                this.$store.dispatch('setHeightPos', null);

                let selectionRectangle = paper.project.getItem({ name: "selection" });
                if (selectionRectangle) {
                    selectionRectangle.remove();
                }

                paper.project.layers.selecter.removeChildren();
                this.$root.$emit('bv::hide::modal', 'modal-delete');
            },

            select(tool) {
                if (tool != this.tool) {
                    this.$store.dispatch('setWhiteboardTool', tool);
                } else {
                    this.$store.dispatch('setWhiteboardTool', 'selecter');
                }
            },
        },

        created() {
            window.addEventListener("keydown", this.shortcutListener);
        },

        destroyed() {
            window.removeEventListener("keydown", this.shortcutListener);
        }
    }
</script>

<style lang="scss" scoped>
    $color-select: #e6e9f0;

    .historyBox {
        width: 75px;
        padding: 0.5rem;
        border-radius: 10px;
        grid-template-columns: auto auto;
        gap: 0.5rem;
        margin-bottom: 75px;

        svg {
            background-color:$color-select;
            padding: 8px;
            border-radius: 10px;
        }

        .fly-over-tool {
            position: absolute;
            left: 73px;
            min-width: 250px;
            top: -2px;
            padding: 5px 10px;
            z-index: -1;

            &:after {
                content: "";
                width: 0px;
                height: 0px;
                border-top: 15px solid transparent;
                border-right: 15px solid #fff;
                border-bottom: 15px solid transparent;
                border-left: 15px solid transparent;
                top: 14px;
                left: -16px;
                position: absolute;
            }
        }
    }

    .tool {
        color: #343a40;
        margin: 7px;
        border-radius: 10px;
        text-align: center;
        height:50px;
    }
</style>
